"use strict";

exports.__esModule = true;
exports.DeviceSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _icons = require("@blueprintjs/icons");
var _Selector = require("../../Core/Selector");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.uuid;
}
function renderItemText(input) {
  return input.name;
}
function renderItemLabel(input) {
  return input.uuid;
}
function itemPredicate(query, device) {
  var q = query.toLowerCase();
  return device.uuid.toLowerCase().indexOf(q) !== -1 || device.name.toLowerCase().indexOf(q) !== -1;
}

/**
 * Allows a user to select device(s) from a list.
 */
var DeviceSelector = exports.DeviceSelector = function DeviceSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
      placeholder: props.multiple ? translate("DeviceSelector.placeholder.multiple", "Select Devices") : translate("DeviceSelector.placeholder.single", "Select Device"),
      dataTestId: "DeviceSelector",
      getKey: getKey,
      renderItemText: renderItemText,
      renderItemLabel: renderItemLabel,
      itemPredicate: itemPredicate,
      icon: _icons.IconNames.BOX
    }, props));
  });
};